import { createState, useState } from '@hookstate/core';

const NotificationsCountState = createState({unseenCount: 0});

export default function UseNotificationsCountState() {
    return useState(NotificationsCountState)
}
